import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=3c22b824&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=3c22b824&prod&scoped=true&lang=css"
import style1 from "../../../static/css/common.css?vue&type=style&index=1&id=3c22b824&prod&scoped=true&lang=css&external"
import style2 from "../../../static/css/videoDetail.css?vue&type=style&index=2&id=3c22b824&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22b824",
  null
  
)

export default component.exports